<template>
    <MainContent title="Editar equipo">
        <template v-slot:header>
            <h3 class="card-title p-0">Editar equipo</h3>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <FormEquipo v-if="!loading" :equipo="equipo" @terminado="editarEquipo"/>
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormEquipo from "@/components/backend/bases/equipos/FormEquipo";

    export default {
        data() {
            return {
                loading: false,
                equipo: null,
                equipo_id: this.$route.params.equipo_id
            }
        },
        methods: {
            getEquipo() {
                this.loading = true;

                const params = {
                    lista_id: this.lista_id,
                    equipo_id: this.equipo_id,
                    filters: {}
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.equipos.show'), params).then(res => {
                    this.equipo = res.data.data;
                    this.loading = false;
                });
            },
            editarEquipo() {
                this.loading = true;
                this.equipo.filters = {};

                this.equipo.lista_id = this.lista_id;
                this.equipo.equipo_id = this.equipo_id;

                this.$store.dispatch(this.config.getVuexAlias('back.bases.equipos.update'), this.equipo).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.bases.equipos', params: { lista_id: this.lista_id } });
                    this.loading = false;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.loading = false;
                });
            },
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        created() {
            this.getEquipo();
        },
        components: { MainContent, FormEquipo }
    }
</script>